import { putRequest } from "../RestServices";
import * as urls from "../../api/searchRevealUnits/url";
export const createRevealVehicles = async (payload) => {
  try {
    return await putRequest(urls.CREATE_REVEAL_UNITS, payload);
  } catch (err) {
    return err;
  }
};
